import { AnalyticsService } from './../analytics/analytics.service';
import { Observable } from 'rxjs/Observable';
import { Http, RequestOptions, RequestOptionsArgs, Headers } from '@angular/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Settings } from './../settings/settings';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import * as en from 'date-fns/locale/en';
import { ISubscription } from 'rxjs/Subscription';
import { AuthService, User } from './../user/auth.service';
import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, AfterViewChecked, AfterViewInit, } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { RegistryService } from '../registry/registry.service';
import { environment } from './../../environments/environment';
import { Intercom } from 'ng-intercom';
import { DatepickerOptions, NgDatepickerComponent } from 'ng2-datepicker';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { StarterRegistry } from '../templates/starter-registry';
import { SettingsStateStore } from '../settings/settings.state.store';
const destinationGifts = require('../templates/destination-gifts.json');
import { filter, take } from 'rxjs/operators';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Website } from '../website-builder/wedding';


@Component({
  selector: 'app-reg-setup-popup',
  templateUrl: './reg-setup-popup.component.html',
  styleUrls: ['./reg-setup-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }

})


export class RegSetupPopupComponent implements OnInit, AfterViewInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  @ViewChild('dayPicker') datepickerComponent: NgDatepickerComponent;
  hide: boolean;
  user: User;
  listSelectedCountries: string;
  registry: Registry;
  registryNameChanged = new Subject<string>();
  selectedDestinations: Array<string> = new Array<string>();
  selectionMade = false;
  noUrl = false;
  checkingDomain = false;
  @Output() saved: EventEmitter<string> = new EventEmitter<string>();
  @Output() processing: EventEmitter<string> = new EventEmitter<string>();
  @Input() skipLoad: boolean;
  @Input() mode: string;
  public hitchdForm: FormGroup;
  buttonText = 'Get Started';
  destinationsList;
  public procesing: boolean;
  public registryNameAvailable?: boolean;
  days: Array<number>;
  dateSelected: boolean = false;
  years: Array<number>;
  settings: Settings;

  registryName: string;
  showDropDown = false;
  token: string;
  translationType: string;
  currency: string
  country: string;
  guestCount = 0;
  noDate = false;
  website: Website;
  secondLanguage = '';
  secondLanguageCode = '';
  defaultLanguage = 'English';
  today: Date = new Date();
  noGuestCount = false;
  hasStripeSetup = false;
  submitting = false; // @ollie - set this to true to view the spinner mode indefinately - set back to false when you are done.5
  slide = 1;
  date: Date = new Date(Date.now());
  yourName: string;

  partnersName: string;

  errorMessage: string;
  socialSubmitting = false;
  subscription: ISubscription;
  submitted = false;
  emailSet = false;
  options: DatepickerOptions = {
    minYear: 2024,
    maxYear: 2029,
    displayFormat: 'MMMM D YYYY',
    barTitleFormat: 'MMMM YYYY',
    dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    locale: en,
    barTitleIfEmpty: 'Click to select a date',
    minDate: new Date(Date.now()), // Minimal selectable date
    // Maximal selectable date
    //  placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    //  addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    // Optional, value to pass to [ngStyle] on the input field
    // fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    // useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown
  };


  @Input() showPopup = true;
  starterRegistries: StarterRegistry[];
  signupModeWebsite: boolean;
  signupModeRegistry: boolean;
  imJustBrowseingSignupMode: boolean;

  signupModeGuestList: boolean;
  urlErrorTaken: boolean = false;
  urlErrorInvalid: boolean = false;
  domainGood: boolean;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private _http: Http,
    private _router: Router,
    private _settingsStateService: SettingsStateStore,
    private _websiteState: WebsiteStateStore,
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,

    private _intercom: Intercom,

  ) {
    // this._router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe((event: NavigationEnd) => {
    //   this.showPopup = event.url === '/setup';
    // });

  }
  ngAfterViewInit(): void {
    if (this.datepickerComponent) {
      this.datepickerComponent.registerOnChange((test) => {
        this.date = new Date(test)
        this.dateClicked();
      });
    }
  }
  ngAfterViewChecked(): void {

  }

  collaceSelectedCountries() {
    this.listSelectedCountries = "";
    this.selectedDestinations.forEach(destination => {
      if (!this.listSelectedCountries) {
        this.listSelectedCountries = destination
      } else {
        this.listSelectedCountries += ", " + destination;
      }
    });
  }

  getLanguageCode(language) {
    switch (language.toLowerCase()) {
      case 'danish':
        return 'DA';
      case 'dutch':
        return 'NL';
      case 'finnish':
        return 'FI';
      case 'french':
        return 'FR';
      case 'german':
        return 'DE';
      case 'greek':
        return 'EL';
      case 'italian':
        return 'IT';
      case 'norwegian':
        return 'NO';
      case 'portuguese':
        return 'PT';
      case 'spanish':
        return 'ES';
      case 'swedish':
        return 'SV';
      case 'polish':
        return 'PL';
      default:
        return 'EN';  // Default to English
    }
  }

  changeSecondLang() {
    this.defaultLanguage = 'English';
    //this.disableSave = false
    this.secondLanguageCode = this.getLanguageCode(this.secondLanguage);
  }
  toggleDropDown(event: Event) {
    event.stopPropagation();
    this.showDropDown = !this.showDropDown;
  }

  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }



  }



  public setImageShape(shape) {
    this.registry.imageShape = shape;
    if (this._registryFirebaseService.isAnonRegPath()) {
      this._registryFirebaseService.saveAnonRegistry(this.registry);
    } else {
      this._registryFirebaseService.saveRegistry(this.registry);
    }
    this.selectionMade = true;
    this._registryFirebaseService.propergateRegistrtyObservable(this.registry);
  }


  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 2;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 16); // 20px = line-height: 1.25rem
  }

  createDefaultGifts() {

  }



  updateReg(skipClose = false) {

    if (this._registryFirebaseService.isAnonRegPath()) {
      this._registryFirebaseService.saveAnonRegistry(this.registry)
      this.close();
      return;
    }

    this._registryFirebaseService.updateRegLayout(this.registry);
    this.close();
  }
  updateUser(): Promise<any> {
    this.user.dismissCreatePopup = true;
    return this._registryFirebaseService.updateUser(this.user);

  }
  toggleSelectWebsiteSignupMode() {
    this.signupModeWebsite = !this.signupModeWebsite;
    this.imJustBrowseingSignupMode = false;
  }

  toggleSelectGuestListeSignupMode() {
    this.signupModeGuestList = !this.signupModeGuestList;
    this.imJustBrowseingSignupMode = false;
  }

  toggleSelectRegistrySignupMode() {
    this.signupModeRegistry = !this.signupModeRegistry;
    this.imJustBrowseingSignupMode = false;
  }

  toggleImJustBrowseingSignupMode() {
    this.signupModeWebsite = false;
    this.signupModeRegistry = false;
    this.imJustBrowseingSignupMode = !this.imJustBrowseingSignupMode;
  }

  giftAssistant() {
    this.updateUser().then(() => {

      this.router.navigate(['/registry/gift-assistant']);

    });

  }

  setPresetUrl(text: string) {
    this.registryName = text;
    this.resetUrlChecks(null);
    this.checkDomainName(text);
  }

  createGift() {
    this.updateUser().then(() => {

      this.router.navigate(['/registry/create-gift']);

    });

  }

  openCalander() {
    this.datepickerComponent.toggle()

    this.dateSelected = false;
  }
  dateClicked() {
    this.dateSelected = true;
    this.goToSlide3();


  }

  close() {

    if (!this.showPopup) {
      return;
    }
    this.setHashTag();
    this._analyticsService.trackEvent('Registry Setup popup closed', {});
    this.router.navigateByUrl('/overview');
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    localStorage.setItem("dismiss_reg_setup", "true");
    this.updateReg(true);

  }

  onDateSelect(date: any) {

  }
  setEmail() {
    this.emailSet = true;
  }
  getSlideNameByStepNumber(step: number) {
    switch (step) {
      case 1: {
        return "names - step 1";
      }
      case 2: {
        return "wedding details - step 2";
      }
      case 3: {
        return "currency";
      }
      case 4: {
        return "destination";
      }
    }
  }

  goToSlide1() {
    this.slide = 1
    this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 1 });
  }

  goToSlide2() {
    let toSave = false;

    if (this.yourName) {
      this.registry.firstName = this.yourName;
      toSave = true;
    }
    if (this.partnersName) {
      this.registry.partnerFirstName = this.partnersName;
      toSave = true;
    }
    if (toSave) {
      this._registryFirebaseService.saveRegistry(this.registry)
    }
    this.slide = 2
    this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 2 });
  }

  goToSlide3() {
    let toSave = false;
    if (!this.noDate && this.date) {
      this.registry.weddingDay = (this.date.getDate());
      this.registry.weddingMonth = (this.date.getMonth() + 1);
      this.registry.weddingYear = (this.date.getFullYear());
      toSave = true;
    } else if (this.noDate) {
      this.registry.weddingDay = null;
      this.registry.weddingMonth = null;
      this.registry.weddingYear = null;
      toSave = true;
    }
    if (toSave) {
      this._registryFirebaseService.saveRegistry(this.registry)
    }
    this.slide = 3
    this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 3 });

  }
  goToSlide5() {
    this.slide = 5;
    this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 5 });
  }
  goToSlide4() {
    let toSave = false;

    if (this.registryName) {
      this.registryName = this.registryName.trim().toLowerCase();
    }


    if (toSave) {
      this._registryFirebaseService.saveRegistry(this.registry)
    }
    this.slide = 4
    this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: 4 });

  }

  showSlide(isForward: boolean) {
    if (this.yourName && this.partnersName) {
      this.registryName = this.yourName.trim().toLowerCase() + 'and' + this.partnersName.trim().toLowerCase();
    }
    if (isForward) {
      let stepName = this.getSlideNameByStepNumber(this.slide)
      this._analyticsService.trackEvent('Signup Form - Next button clicked', { destination_step_no: this.slide + 1, destination_step_name: stepName });
      if (this.slide === 2) {
        this.slide = this.slide + 1;

      } else {

        if (!this.noDate && this.date) {
          this.hitchdForm.controls['weddingDay'].setValue(this.date.getDate());
          this.hitchdForm.controls['weddingMonth'].setValue(this.date.getMonth() + 1);
          this.hitchdForm.controls['weddingYear'].setValue(this.date.getFullYear());
        }

        this.slide = this.slide + 1;
      }
    } else if (this.slide === 4) {
      this.slide = this.slide + 1;


    }
    if (!isForward) {
      this._analyticsService.trackEvent('Signup Form - Back button clicked', { step: this.slide - 1 });
      if (this.slide === 0) {

      }
      else {
        this.slide = this.slide - 1;
      }
    }

  }


  sortStarterRegistriesAlphabeticallyByCountryName() {
    if (!this.starterRegistries || this.starterRegistries.length == 0) {
      return
    }
    this.starterRegistries.sort((a, b) => {
      if (a.country < b.country) { return -1; }
      if (a.country > b.country) { return 1; }
      return 0;
    })
  }

  getImageUrl(country: string) {
    country = country.toLowerCase();
    country = country.replace(" ", "")
    return "/assets/public/images/flags/" + country + ".svg"

  }

  removeStarterRegistriesThatHaveZeroGifts() {
    if (!this.starterRegistries || this.starterRegistries.length == 0) {
      return
    }

    this.starterRegistries = this.starterRegistries.filter(registry => {
      return registry.gifts.length > 0
    })
  }


  ngOnInit() {
    this.date.setMonth(this.date.getMonth() + 6);


    this._settingsStateService.getState().subscribe(state => {
      this.settings = state.settings;

    });
    let fromPage = localStorage.getItem('fromPage');

    if (fromPage == 'registry') {
      this.signupModeRegistry = true;
      this.signupModeWebsite = false;


    } else if (fromPage == 'wedding-website') {
      this.signupModeRegistry = false;
      this.signupModeWebsite = true;


    }

    this.user = this.route.snapshot.data.user;
    this.settings = this.route.snapshot.data.settings;
    this.website = this.route.snapshot.data.website;
    

    if (this.website && this.website.id || this.settings && this.settings.completedGuestListOnboarding || this.settings && this.settings.completedWebsiteOnboarding || this.settings && this.settings.completedRegistryOnboarding) {
     this.router.navigate(['/website/builder']);
     return;
    } else if (this.settings && this.settings.completedGuestListOnboarding) {
      this.router.navigate(['/registry']);
      return;
    }

    if (this.user) {
      this._analyticsService.identify(this.user, {});
    }

    if (!this.registry) {
      this.registry = this.route.snapshot.data.registry;

      if (!this.registry && location.pathname.includes('your-registry')) {
        this.registry = this._registryFirebaseService.getAnonRegistry();

      }

      this.registryNameChanged.pipe(
        debounceTime(1000)
      ).subscribe(newValue => {

        this.checkDomainName(newValue);
      });

      this._registryFirebaseService.currentRegistry.subscribe(registry => {
        if (registry) {
          this.registry = registry;
          this.country = registry.country;
          this.currency = registry.currency;
          if (registry.firstName != "You") {
            this.yourName = registry.firstName;
          }
          if (registry.partnerFirstName != "Fiance") {
            this.partnersName = registry.partnerFirstName;
          }

          if (this.registry.weddingDay) {
            this.date = new Date(
              this.registry.weddingYear,
              this.registry.weddingMonth - 1,
              this.registry.weddingDay

            );
          }
        }
      });
      if (this.registry && !this.registry.font) {
        this.registry.font = 'classic';
      }
    }

    let starterRegistryString = localStorage.getItem('starter-registries');

    if (!starterRegistryString) {
      this.starterRegistries = destinationGifts;
    } else {

      this.starterRegistries = JSON.parse(starterRegistryString);
    }


    if (this.starterRegistries && this.starterRegistries.length > 0) {
      this.starterRegistries.forEach(reg => {
        reg.countryFlagImageUrl = this.getImageUrl(reg.country);
      })
      this.removeStarterRegistriesThatHaveZeroGifts();
      this.sortStarterRegistriesAlphabeticallyByCountryName();
    }
    this._registryService.showGenericPopup$.subscribe(popupType => {

      if (popupType == "setup") {

        this.showPopup = true;
        this.changeDetectorRef.detectChanges();
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
      } else if (this.showPopup) {
        this.close();
      }

    });



    const body = document.getElementsByTagName('body')[0];




    if (!this.skipLoad) {

      this.buttonText = 'Save';
    }


  }
  onCheckledUrl() {
    this.noUrl = !this.noUrl;
    if (this.noUrl) {
      this.registryName = null;
    }
    this.resetUrlChecks(null);
    this.checkingDomain = false;
    this.registryName = null;
  }
  previousValue = '';
  resetUrlChecks(event) {


    if (event && event.target && event.target.value == this.previousValue) {
      return;
    }
    //this.checkingDomain = true;
    this.urlErrorTaken = false;
    this.urlErrorInvalid = false;
    this.domainGood = false
  }
  test() {
  }
  onCheckledGuestCount(checked) {


    if (checked) {
      this.noGuestCount = true;
      this.hitchdForm.controls['guestCount'].setValue(null);
      this.hitchdForm.controls['guestCount'].clearValidators();
      this.guestCount = null;

    } else {
      this.noGuestCount = false;

      this.hitchdForm.controls['guestCount'].setValidators(Validators.required);
    }
    this.hitchdForm.markAsTouched();
  }

  onCheckled(checked: boolean) {
    //this.date = null;

    if (checked) {
      this.noDate = true;
      this.today = this.date;
      this.dateSelected = false;

    } else {
      this.noDate = false;
      // this.date = new Date();
      if (!this.datepickerComponent.isOpened) {
        this.datepickerComponent.toggle();
      }
      this.dateSelected = false;

    }

  }

  checkDomainName(domainName: string) {
    this.urlErrorInvalid = false;
    let domainNameContainsLettersAndNumbersOnly = /^[a-zA-Z0-9]+$/.test(domainName);

    if (!domainNameContainsLettersAndNumbersOnly) {
      this.urlErrorInvalid = true;
      this.checkingDomain = false;
      return;
    }


    this.urlErrorTaken = false;
    if (domainName) {
      domainName = domainName.toLowerCase();

      this._registryFirebaseService
        .registryByName(domainName)
        .take(1)
        .subscribe(registry => {
          //
          if (registry) {
            this.urlErrorTaken = true;
            this.checkingDomain = false;
          } else {
            this.urlErrorTaken = false;
            this.checkingDomain = false;
            this.domainGood = true;
          }
        });
    }
  }

  setCurrency() {
    switch (this.country) {
      case 'AU': {
        this.currency = 'AUD';
        break;
      }
      case 'MX': {
        this.currency = 'MXN';
        break;
      }
      case 'CA': {
        this.currency = 'CAD';
        break;
      }
      case 'GB': {
        this.currency = 'GBP';
        break;
      }
      case 'NZ': {
        this.currency = 'NZD';
        break;
      }
      case 'US': {
        this.currency = 'USD';
        break;
      }
      case 'US': {
        this.currency = 'USD';
        break;
      }
      case 'AT': {
        this.currency = 'EUR';
        break;
      } case 'BE': {
        this.currency = 'EUR';
        break;
      }
      case 'ES': {
        this.currency = 'EUR';
        break;
      }
      case 'EE': {
        this.currency = 'EUR';
        break;
      } case 'FI': {
        this.currency = 'EUR';
        break;
      } case 'FR': {
        this.currency = 'EUR';
        break;
      } case 'DE': {
        this.currency = 'EUR';
        break;
      } case 'GR': {
        this.currency = 'EUR';
        break;
      } case 'IE': {
        this.currency = 'EUR';
        break;
      } case 'IT': {
        this.currency = 'EUR';
        break;
      } case 'LV': {
        this.currency = 'EUR';
        break;
      } case 'LT': {
        this.currency = 'EUR';
        break;
      } case 'LU': {
        this.currency = 'EUR';
        break;
      } case 'NL': {
        this.currency = 'EUR';
        break;
      } case 'PT': {
        this.currency = 'EUR';
        break;
      }
      case 'SG': {
        this.currency = 'SGD';
        break;
      }
      case 'HK': {
        this.currency = 'HKD';
        break;
      }
      case 'US': {
        this.currency = 'USD';
        break;
      }

      case 'SE': {
        this.currency = 'SEK';
        break;
      }

      case 'NO': {
        this.currency = 'NOK';
        break;
      }
      case 'CH': {
        this.currency = 'CHF';
        break;
      }
    }
  }


  markFormAsTouched() {
    for (const key in this.hitchdForm.controls) {
      if (this.hitchdForm.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>this.hitchdForm.controls[key];
        {
          control.markAsTouched();
        }
      }
    }
  }

  CreateRegistryV2(): Promise<any> {
    const form: any = this.hitchdForm.value;
    form.guestCount = this.guestCount;
    form.backgroundHeaderImageUrl = 'https://images.unsplash.com/photo-1527904219733-fddc74937915?hex=#1A1E1B';
    form.introTitle = 'Welcome to our registry';
    form.introductionText =
      'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
    if (form.firstName && form.partnerFirstName) {
      form.hashtag = form.firstName.toLowerCase().trim() + 'and' + form.partnerFirstName.toLowerCase().trim();
    } else {
      form.hashtag = '';
      form.hideHashtag = true;
    }
    form.registryName = (form.registryName as string).toLowerCase();
    form.showRecommendedAmount = false;
    const campaign = localStorage.getItem('utm_campaign');
    const referal_user_id = localStorage.getItem('referal_id');
    const source = localStorage.getItem('utm_source');
    const landingPage = localStorage.getItem('landingPage');
    const partnershipId = localStorage.getItem('partnershipId');
    if (landingPage) {
      form.landingPage = landingPage;

    }
    if (source) {
      form.source = source;
    }
    if (campaign) {
      form.campaign = campaign;
    }
    if (referal_user_id) {
      form.referalUserId = referal_user_id;
    }



    if (partnershipId) {
      form.partnershipId = partnershipId;
    }

    this._analyticsService.update({ campaign: campaign, source: source, landingPage: landingPage });
    // if ((window as any).analytics && (window as any).analytics.user) {
    //   const traits = (window as any).analytics.user().traits();
    //   form.rollouts =  {
    //     rollout_test: 'pricing',
    //     rollout_country: traits.rollout_country,
    //     rollout_currency: traits.rollout_currency,
    //     rollout_in_pricing_test: traits.rollout_in_pricing_test,
    //     rollout_originalCountry: traits.rollout_originalCountry,
    //     rollout_price: traits.rollout_price,
    //     rollout_price_segment: traits.rollout_price_segment,
    //     rollout_userId: traits.rollout_userId
    //   };
    // }


    form.email = null;
    form.password = null;
    form.userId = this.user.uid;
    const formValue: any = JSON.stringify(form);

    localStorage.setItem('tempReg', formValue);

    return this._registryFirebaseService.createRegistry(formValue, this.user);

  }

  CreateRegistry(): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });

    const form: any = this.hitchdForm.value;
    form.token = this.token;

    // form.baseRegistryTemplate = localStorage.getItem('baseRegistryName');
    if (!this.noDate && this.date) {
      form.weddingDay = (this.date.getDate());
      form.weddingMonth = (this.date.getMonth() + 1);
      form.weddingYear = (this.date.getFullYear());
    }
    //

    form.backgroundHeaderImageUrl = 'https://images.unsplash.com/photo-1527904219733-fddc74937915?hex=#1A1E1B';
    form.introTitle = 'Welcome to our registry';
    form.introductionText = 'We\'re incredibly thankful to have everything we already need. So, we\'re skipping out of tradition and would love for you to help us create some new experiences instead.';
    if (form.firstName && form.partnerFirstName) {
      form.hashtag = form.firstName.toLowerCase().trim() + 'and' + form.partnerFirstName.toLowerCase().trim();
    } else {
      form.hashtag = '';
      form.hideHashtag = true;
    }
    form.guestCount = this.guestCount;
    form.registryName = (form.registryName as string).toLowerCase();
    const campaign = localStorage.getItem('utm_campaign');
    const source = localStorage.getItem('utm_source');
    const referal_user_id = localStorage.getItem('referal_id');
    const landingPage = localStorage.getItem('landingPage');
    const partnershipId = localStorage.getItem('partnershipId');
    if (landingPage) {
      form.landingPage = landingPage;

    }
    if (source) {
      form.source = source;
    }
    if (campaign) {
      form.campaign = campaign;
    }

    if (referal_user_id) {
      form.referalUserId = referal_user_id;
    }


    if (partnershipId) {
      form.partnershipId = partnershipId;
    }

    this._analyticsService.update({ campaign: campaign, source: source, landingPage: landingPage });
    if ((window as any).analytics) {
      const traits = (window as any).analytics.user().traits();
      form.rollouts = {
        rollout_test: 'pricing',
        rollout_country: traits.rollout_country,
        rollout_currency: traits.rollout_currency,
        rollout_in_pricing_test: traits.rollout_in_pricing_test,
        rollout_originalCountry: traits.rollout_originalCountry,
        rollout_price: traits.rollout_price,
        rollout_price_segment: traits.rollout_price_segment,
        rollout_userId: traits.rollout_userId
      };
    }


    form.email = null;
    form.password = null;

    const formValue: any = JSON.stringify(form);

    return this._http.post(environment.firebase.clouldFunctionHost + '/createRegistryV2', formValue, options)
      .map(response => {

        const formdata = JSON.parse(formValue);
        if (formdata && formdata.firstName) {
          this._analyticsService.update({ name: formdata.firstName });
        }
        this._analyticsService.update({ registryUrl: 'https://www.hitchd.com/' + this.registryName });

        return response;
      });

  }

  setHashTag() {

    if (this.yourName && this.partnersName) {
      this.registry.hashtag = this.yourName.toLowerCase().trim() + 'and' + this.partnersName.toLowerCase().trim();
    }
  }
  save() {
    console.log("save", this.settings);
    this.setHashTag()

    if (!this.settings) {
    }

    // if (this.imJustBrowseingSignupMode || (!this.signupModeWebsite && !this.signupModeRegistry)) {
    //   this.signupModeRegistry = true;
    //   this.signupModeWebsite = true;
    // }

    let enableWebsite = this.signupModeWebsite;
    if (!enableWebsite && !this.signupModeGuestList &&
      !this.signupModeWebsite &&
      !this.signupModeRegistry) {
      enableWebsite = true;
    }

    if (this.signupModeRegistry) {
      this.settings.registryEnabled = true;
      this.registry.signupForRegistry = true;
    }

    if (this.signupModeWebsite) {
      this.settings.weddingWebsiteEnabled = true;
      this.registry.signupForWebsite = true;
    }
    if (this.signupModeGuestList) {
      this.settings.weddingWebsiteEnabled = true;
      this.registry.signupForGuestListRsvp = true;
    }

    if (!this.signupModeGuestList &&
      !this.signupModeWebsite &&
      !this.signupModeRegistry
    ) {

      this.settings.registryEnabled = true;
      this.settings.weddingWebsiteEnabled = true;

    }



    if (this.registryName) {
      this.registry.registryName = this.registryName.toLowerCase().trim();
    }

    if (this.secondLanguage) {
      this.settings.secondLanguage = this.secondLanguage;
      this.settings.defaultLanguage = this.defaultLanguage;
      this.settings.enableTranslations = true;
      this._settingsStateService.updateSettings(this.settings);
    }
    this._analyticsService.identifySegmentUserIdWithData(this.settings.userId, {
      onboardingSelection_guestList: this.signupModeGuestList,
      onboardingSelection_website: this.signupModeWebsite,
      onboardingSelection_registry: this.signupModeRegistry,
      onboardingSelection_dateSupplied: this.date ? true : false,
      onboardingSelection_urlSupplied: this.noUrl ? false : true,
      onboardingSelection_translationLanguage: this.secondLanguage,

    });

    
    if (this.settings.weddingWebsiteEnabled) {
      this._websiteState.initWebsite(this.settings.userId, this.registry, this.secondLanguage, enableWebsite, this.signupModeRegistry);
    }



    if (this.currency) {
      this.registry.currency = this.currency;
    }
    if (this.country) {
      this.registry.country = this.country;
    }

    this._registryFirebaseService.saveRegistry(this.registry);

    let giftsCreated = 0;
    if (this.selectedDestinations && this.selectedDestinations.length > 0) {
      this.selectedDestinations.forEach(destination => {
        giftsCreated = giftsCreated + this.createSectionAndGiftsForEachDestination(destination);
      });


      const countries = this.selectedDestinations.map(destination => destination);

      let result = '';
      if (countries.length > 1) {
        if (countries.length === 2) {
          result = countries.join(' and ');
        } else {
          const lastCountry = countries.pop();
          result = countries.join(', ') + ', and ' + lastCountry;
        }
      } else {
        result = countries[0];
      }

      if (this.settings && this.settings.weddingWebsiteEnabled) {


        this._websiteState.initWebsite(this.settings.userId, this.registry, this.secondLanguage, enableWebsite, this.signupModeRegistry);
      }



      this._analyticsService.trackEvent('Onboarding Completed', {
        onboardingSelection_guestList: this.signupModeGuestList,
        onboardingSelection_website: this.signupModeWebsite,
        onboardingSelection_registry: this.signupModeRegistry,
        onboardingSelection_dateSupplied: this.date ? true : false,
        onboardingSelection_urlSupplied: this.noUrl ? false : true,
        onboardingSelection_translationLanguage: this.secondLanguage,

      });


      this._registryService.emitGenericToastMsg(giftsCreated + " gifts created for " + result);

      this.settings.weddingWebsiteEnabled = true;
      this.settings.registryEnabled = true;
      this._settingsStateService.updateSettings(this.settings);
    }



    this.showPopup = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    localStorage.setItem("dismiss_reg_setup", "true");
    this._analyticsService.identify(this.user, { registrySetupSelectedCountries: this.selectedDestinations });

    if (!this.signupModeGuestList &&
      !this.signupModeWebsite &&
      this.signupModeRegistry) {
      this.router.navigate(['/registry']);
    } else {
      this.router.navigate(['/website/builder']);
    }




  }

  skipDestinations() {
    this._analyticsService.trackEvent('Registry Setup - Destinations - Skip button pressed', {});
    this.close();
  }

  createSectionAndGiftsForEachDestination(destinationName: string) {
    let giftsForDestination = this.starterRegistries.filter(x => x.country == destinationName)[0].gifts;
    this._registryFirebaseService.createSectionWithGifts(destinationName, giftsForDestination);

    return giftsForDestination.length;
  }





  signInFacebook() {
    this.hitchdForm.controls['email'].clearValidators();
    this.hitchdForm.controls['password'].clearValidators();
    this.submitting = true;
    this._authService.facebookLogin().then(x => {

      this.subscription = this._authService.user.subscribe(user => {

        if (user != null) {
          this.submitting = true;
          this.markFormAsTouched();
          this._authService.authToken().subscribe(token => {
            this.token = token;
            this.CreateRegistry().subscribe(x => {
              this._registryService.emitWelcomePopup();
              this._registryService.sendFbTrackEvent('Get-started completed');

              location.href = '/registry';
            });
          });
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'The email address is already in use';
        }

        this.socialSubmitting = false;
        this.submitting = false;
      });
  }


  toggleSelect(destination: string) {
    if (this.selectedDestinations.length == 3 && !this.selectedDestinations.includes(destination)) {
      return;
    }
    if (this.selectedDestinations.includes(destination)) {
      this.selectedDestinations.splice(this.selectedDestinations.indexOf(destination), 1);
    } else {
      this.selectedDestinations.push(destination);
    }
    this.collaceSelectedCountries();
  }




  signInGoogle() {
    this.hitchdForm.controls['email'].clearValidators();
    this.hitchdForm.controls['password'].clearValidators();
    this.submitting = true;
    this._authService.googleLogin().then(x => {

      this.subscription = this._authService.user.subscribe(user => {

        if (user != null) {
          this.submitting = true;
          this.markFormAsTouched();
          this._authService.authToken().subscribe(token => {
            this.token = token;
            this.CreateRegistry().subscribe(x => {
              this._registryService.emitWelcomePopup();
              this._registryService.sendFbTrackEvent('Get-started completed');

              location.href = '/registry';
            });
          });
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'The email address is already in use';
        }

        this.socialSubmitting = false;
        this.submitting = false;
      });
  }

  goToStep5() {

    //   if(this.secondLanguage){



    //   this._authService.authToken().pipe(take(1)).subscribe(token => {

    //     let formValue = {
    //       token: token,
    //       enableTranslations: true,
    //       secondLanguage: this.secondLanguage,
    //       defaultLanguage: this.defaultLanguage,
    //       onlyIfEmpty: false,

    //     }
    //     const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    //     const options = new RequestOptions({ headers: headers });

    //     return this._http
    //       .post(environment.firebase.clouldFunctionHost + '/translate', formValue, options)
    //       .toPromise()
    //       .then((response: any) => {


    //         // this.settingsProcessing = false;
    //         // this._router.navigate(['registry', 'add-payment-methods'])
    //       })
    //       .catch((e: any) => {
    //         // this.settingsProcessing = false;


    //         this.translationType = null;
    //       })
    //   })

    // }
    this.slide = 5;

  }

  setFullStoryId(email) {
    const FS = window['FS'];
    if (FS) {
      // This is an example script - don't forget to change it!
      FS.identify(email, {
        email: email,
        // TODO: Add your own custom user variables here, details at
        // http://help.fullstory.com/develop-js/setuservars
        reviewsWritten_int: 14
      });
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/reg-setup/reg-setup-popup.component.ts